/* eslint-disable import/no-default-export */
import Storage, { StorageProxy } from 'app/common/lib/storage';

export default function lastOrganization(storage: StorageProxy = Storage) {
  const orgIdKey = 'idLastOrganization';
  const noOrgId = 'none';

  return {
    NO_ORGANIZATION: noOrgId,
    LAST_ORGANIZATION: orgIdKey,

    set(idOrganization: string): void {
      storage.set(orgIdKey, idOrganization ? idOrganization : noOrgId);
    },

    get(): string | null {
      const value = storage.get(orgIdKey);

      return typeof value === 'string' ? value : null;
    },
  };
}
